import classnames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import Button from "./Button"

const StyledButton = styled(Button)`
  .Button__content-wrapper {
    height: 100%;
  }
`

const IconButton = React.forwardRef(
  (
    {
      icon,
      rotate,
      flip,
      label = null,
      children,
      rounded = false,
      size = 30,
      sizeUnit = "px",
      buttonSize = "medium",
      styleType = "blank",
      iconProps,
      ...rest
    },
    ref
  ) => {
    const className = classnames(
      "IconButton",
      `IconButton__${icon}`,
      rest.className
    )
    const styles = {
      width: `${size}${sizeUnit}`,
      height: `${size}${sizeUnit}`,
      lineHeight: `${size}${sizeUnit}`,
      padding: 0
    }
    const style = { ...styles, ...rest.style }

    if (rounded) {
      style.borderRadius = "8px"
    }

    return (
      <StyledButton
        {...rest}
        ref={ref}
        styleType={styleType}
        className={className}
        style={style}
        size={buttonSize}
        iconProps={{
          icon,
          rotate,
          flip,
          ...iconProps
        }}
        label={label}
      >
        {({ renderChildren }) => (
          <React.Fragment>
            {renderChildren()}
            {children}
          </React.Fragment>
        )}
      </StyledButton>
    )
  }
)

IconButton.displayName = "IconButton"

IconButton.propTypes = {
  ...Button.propTypes,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default IconButton
